import NotificationsNone from "@mui/icons-material/NotificationsNone";
import { Badge, Box, IconButton, Tooltip } from "@mui/material";
import { orange } from "@mui/material/colors";
import { keyframes } from "@mui/material/styles";

const bellBounce = keyframes`
  0% {
    transform: translateY(0) scale(1);
  }
  32% {
    transform: translateY(-2px) scale(1.06);
  }
  64% {
    transform: translateY(1px) scale(0.98);
  }
  100% {
    transform: translateY(0) scale(1);
  }
`;

const NAV_ACTION_SIZE = 40;

export function NotificationBellButton({
  open,
  hasUnread,
  bouncing,
  onClick,
}: {
  open: boolean;
  hasUnread: boolean;
  bouncing: boolean;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}) {
  const icon = <NotificationsNone sx={{ fontSize: 24 }} />;

  return (
    <Box sx={{ display: "flex" }}>
      <Tooltip title="Notifications">
        <IconButton
          aria-label="Notifications"
          onClick={onClick}
          size="small"
          sx={{
            width: NAV_ACTION_SIZE,
            height: NAV_ACTION_SIZE,
            p: 0,
            bgcolor: open ? orange[100] : "transparent",
            color: "action.active",
            transition: "background-color 150ms ease",
            "&:hover": {
              bgcolor: open ? orange[200] : orange[50],
            },
          }}
        >
          {/* The icon bounces, not the button: the open tray is anchored to the button. */}
          <Box
            sx={{
              display: "inline-flex",
              animation: bouncing ? `${bellBounce} 520ms cubic-bezier(0.2, 0.8, 0.2, 1)` : "none",
              "@media (prefers-reduced-motion: reduce)": {
                animation: "none",
              },
            }}
          >
            {hasUnread ? (
              <Badge
                variant="dot"
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: orange[400],
                    boxShadow: (theme) => `0 0 0 1px ${theme.palette.background.paper}`,
                    height: 10,
                    minWidth: 10,
                    right: 8,
                    top: 8,
                  },
                }}
              >
                {icon}
              </Badge>
            ) : (
              icon
            )}
          </Box>
        </IconButton>
      </Tooltip>
    </Box>
  );
}
